.beach :global(.wave) {
  --wave-amplitude: -10px;

  animation: wave 4s ease-in-out infinite;
}

.beach :global(.with-delay) {
  animation-delay: 0.8s;
}

.beach :global(.wave-2) {
  --wave-amplitude: -4px;

  animation: wave 7s ease-in-out infinite;
  scale: 1 2;
  transform-origin: 100% 30%;
}

.beach :global(.wave-3) {
  --wave-amplitude: 4px;

  animation: wave 5s ease-in-out infinite;
}

@keyframes wave {
  0% {
    translate: 0 0;
  }
  50% {
    translate: 0 var(--wave-amplitude);
  }
  100% {
    translate: 0 0;
  }
}

@keyframes wiggle {
  0% {
    rotate: 0deg;
  }
  50% {
    rotate: 4deg;
  }
}

.parasailer :global(.boat) {
  --wave-amplitude: 2px;

  animation:
    wave 1.7s ease-in-out infinite,
    wiggle 1.5s ease-in-out infinite;
  transform-origin: 20% 100%;
}

.parasailer :global(.sail-and-tether) {
  animation: wiggle 8s ease-in-out infinite;
  transform-origin: 20% 100%;
}

.parasailer :global(.sail) {
  animation: wiggle 1.5s ease-in-out infinite reverse;
  transform-origin: 75% 25%;
}
